<div class="h-100 single-report-page">
    <app-admin-report [columns]="zonesToReport" [hasFilters]="true" [apiUrl]="zonesToReportAPI" [isExportToExcel]="true"
                      reportTitle="ADMINISTRATION.ZONE_TO_PACKAGES_SUMMARY_REPORT_TITLE">
    </app-admin-report>
</div>
